import React, {useMemo} from 'react'
import styled from 'styled-components'
import {
  ROBOYU_SENSITIVITY_LEVEL_MAX,
  ROBOYU_SENSITIVITY_LEVEL_MIN,
} from 'consts'
import {useTranslation} from 'i18n'
import {useWindowMode} from 'windows'
import {InputRange, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopExploreSensitivitySliderProps} from './GiftShopExploreSensitivitySliderProps'

const StyledSliderContainer = styled.div`
  width: 100%;
  max-width: ${convertUnit(600)};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: ${convertUnit(20)};
`

const StyledInputRangeContainer = styled.div`
  width: 100%;
`

const StyledAccuracyDescContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export default function GiftShopExploreSensitivitySlider({
  stateRangeValue,
  thumbColor = 'white_1',
  thumbType = 'circle',
  descPosition = 'side',
  isFloating,
  onSlide,
}: GiftShopExploreSensitivitySliderProps) {
  const {translate} = useTranslation()
  const mode = useWindowMode()

  const handleRenderInputRangeLeftDesc = useMemo(
    () => (
      <StyledAccuracyDescContainer style={{textAlign: 'left'}}>
        {!(mode === 'mobile' && !isFloating) && (
          <Paragraph
            fontSize={isFloating ? 's' : 'm'}
            fontWeight="bold"
            color="black_1">
            {translate('giftShop:roboyuAccuracyMediumDesc')}
          </Paragraph>
        )}
        <Paragraph
          fontSize={isFloating ? 'xs' : mode === 'mobile' ? 'xxs' : 's'}
          fontWeight={isFloating || mode !== 'mobile' ? 'medium' : 'bold'}
          color="gray_5">
          {translate('global:medium')}
        </Paragraph>
      </StyledAccuracyDescContainer>
    ),
    [isFloating, mode, translate],
  )

  const handleRenderInputRangeRightDesc = useMemo(
    () => (
      <StyledAccuracyDescContainer style={{textAlign: 'right'}}>
        {!(mode === 'mobile' && !isFloating) && (
          <Paragraph
            fontSize={isFloating ? 's' : 'm'}
            fontWeight="bold"
            color="black_1">
            {translate('giftShop:roboyuAccuracyHighDesc')}
          </Paragraph>
        )}
        <Paragraph
          fontSize={isFloating ? 'xs' : mode === 'mobile' ? 'xxs' : 's'}
          fontWeight={isFloating || mode !== 'mobile' ? 'medium' : 'bold'}
          color="gray_5">
          {translate('global:high')}
        </Paragraph>
      </StyledAccuracyDescContainer>
    ),
    [isFloating, mode, translate],
  )

  return (
    <StyledSliderContainer>
      <StyledInputRangeContainer>
        <InputRange
          showTick
          showSwipeThumb={isFloating}
          stateValue={stateRangeValue}
          descPosition={descPosition}
          thumbColor={thumbColor}
          thumbType={thumbType}
          min={ROBOYU_SENSITIVITY_LEVEL_MIN}
          max={ROBOYU_SENSITIVITY_LEVEL_MAX}
          leftDesc={handleRenderInputRangeLeftDesc}
          rightDesc={handleRenderInputRangeRightDesc}
          onSlide={onSlide}
        />
      </StyledInputRangeContainer>
    </StyledSliderContainer>
  )
}
